import clsx from 'clsx';
import React from 'react';
import { Icon, IconType } from '../../../../components/Icon';

interface Props {
    icon?: IconType;
    label: React.ReactNode;
    url: string;
    additionalClasses?: string[];
    linkAdditionalClasses?: string[];
    attributes?: object;
    linkAttributes?: object;
}

// FIXME: Just use common/components/MenuItemAction, it's the same thing.

export default function NavigationItem({
    url,
    icon,
    label,
    additionalClasses = [],
    linkAdditionalClasses = [],
    attributes = {},
    linkAttributes = {},
}: Props) {
    return (
        <li
            className={clsx(
                'menu__item__action',
                'menu__item__action--truncate',
                {
                    'menu__item__action--has-icon': Boolean(icon),
                },
                ...additionalClasses
            )}
            {...attributes}
        >
            <a
                className={clsx('menu__item__action__link', ...linkAdditionalClasses)}
                href={url}
                {...linkAttributes}
            >
                {icon && (
                    <span className="menu__item__action__icon">
                        <Icon type={icon} />
                    </span>
                )}
                <span className="menu__item__action__label">{label}</span>
            </a>
        </li>
    );
}
